
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { HeroSection } from "@/components/home/HeroSection";
import { FeaturedSection } from "@/components/home/FeaturedSection";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { SEO } from "@/components/SEO";

const Index = () => {
  const location = useLocation();
  const featuredRef = useRef<boolean>(false);

  useEffect(() => {
    if (location.state?.scrollToFeatured && !featuredRef.current) {
      const featuredEventsSection = document.getElementById('featured-events');
      if (featuredEventsSection) {
        featuredEventsSection.scrollIntoView({ behavior: 'smooth' });
        featuredRef.current = true;
      }
    }
  }, [location.state]);

  const scrollToFeaturedEvents = () => {
    const featuredEventsSection = document.getElementById('featured-events');
    featuredEventsSection?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-black text-white flex flex-col">
      <SEO />
      <Header />
      <main className="flex-grow">
        <HeroSection onExploreClick={scrollToFeaturedEvents} />
        <FeaturedSection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
